export const SizeEnum = {
  DEFAULT: 'default',
  SMALL: 'small',
  LARGE: 'large',
} as const;

export type SizeEnum = (typeof SizeEnum)[keyof typeof SizeEnum];

export interface LoadingProps {
  tip: string;
  size: SizeEnum;
  absolute: boolean;
  loading: boolean;
  background: string;
  theme: 'dark' | 'light';
}
